export { SharedUiOverlayModule } from './lib/shared-ui-overlay.module';
export { OverlayService } from './lib/overlay/overlay.service';
export { OverlayModalRef } from './lib/overlay/overlay-ref';
